import React from "react";
import { useTranslation } from "react-i18next";

import { Carousel } from "react-responsive-carousel";

import "react-responsive-carousel/lib/styles/carousel.min.css";

export interface ITermPicture {
  id: number | null;
  src: string;
}

export interface ITermVideo {
  id: number | null;
  youtube_code: string;
}

export interface ITermDetail {
  index: number | null;
  czech: string;
  czech_description: string;
  english: string;
  english_description: string;
  german: string;
  german_description: string;
  pictures: ITermPicture[];
  videos: ITermVideo[];
  link: string;
  last_changed: string;
  last_changed_from: string;
}

interface ITermDetailProperty {
  name: string;
  value: string;
}

const TermDetailProperty: React.FC<ITermDetailProperty> = ({ name, value }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-1" data-cy="term-property">
      {value && (
        <p className="my-0">
          <b>{t(name)}</b>: {value}
        </p>
      )}
    </div>
  );
};

export const TermDetail: React.FC<ITermDetail> = detail => {
  const { t } = useTranslation();
  const pdf_link = `/pdf/${detail.index}.pdf`;
  const detail_link = `/terms/${detail.index}`;

  const pictures = detail.pictures.map(picture => ({
    src: picture.src
  }));
  const videos = detail.videos.map(video => ({
      embedUrl: `https://www.youtube.com/embed/${video.youtube_code}`
    }
  ));
  const showCarousel = pictures.length > 0 || videos.length > 0

  return (
    <div style={{ clear: "both" }} data-cy="term-detail">
      {showCarousel && (
        <div className="mx-5 my-2">
          <Carousel dynamicHeight={true} showThumbs={false}>
            {pictures.map(picture => (
              <div>
                <img src={picture.src} alt="Term visualization"/>
              </div>
            ))}
            {videos.map((video, index, _) => (
              <iframe
                title={`Video ${index}`}
                src={video.embedUrl}
                style={{ height: "calc(100% - 80px)", minHeight: "640px"}}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            ))}
          </Carousel>
        </div>
      )}
      <div>
        <TermDetailProperty name="Czech" value={detail.czech} />
        <TermDetailProperty
          name="Czech description"
          value={detail.czech_description}
        />
        <TermDetailProperty name="English" value={detail.english} />
        <TermDetailProperty
          name="English description"
          value={detail.english_description}
        />
        <TermDetailProperty name="German" value={detail.german} />
        <TermDetailProperty
          name="German description"
          value={detail.german_description}
        />
        <div>
          {detail.link && (
            <p>
              <b>{t("Link")}</b>: <a href={detail.link}>{detail.link}</a>
            </p>
          )}
        </div>
      </div>
      <span className="badge badge-pill badge-dark">
        <a className="text-light" href={pdf_link} data-cy="term-pdf-link">
          PDF
        </a>
      </span>
      <span className="badge badge-pill badge-dark ml-1">
        <a className="text-light" href={detail_link} data-cy="term-detail-link">
          Detail
        </a>
      </span>
    </div>
  );
};
